import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCatalogSummary from './ProductCatalogSummary';
import ProductDetailLayout from './ProductDetailLayout';
import { getProduct } from '../../product-catalog/productPresentation';

const readItems = ['module1', 'module2', 'module3', 'module4', 'module5'];
const writeItems = { module2: 'tool', module3: 'program', module4: 'ncOp' };

export default function HiLinkIntroPage() {
  const { t } = useTranslation('app');
  return (
    <ProductDetailLayout product={getProduct('hi-link')}>
      <ProductCatalogSummary
        productName="Hi-Link"
        title={t('productIntro.hiLink.data.introTitle')}
        imageSrc="/ProductCatalog/hi-link-equipment-xd42.png"
      />

      <section className="hilink-data-section" aria-labelledby="hilink-data-title">
        <div className="hicps-container">
          <h2 id="hilink-data-title">{t('productIntro.hiLink.data.title')}</h2>
          <div className="hilink-data-tables">
            <DataTable
              title={t('productIntro.hiLink.data.readTitle')}
              direction={t('productIntro.hiLink.data.readDirection')}
              rows={readItems.map((item, index) => ({
                module: index + 1,
                description: t(`productIntro.hiLink.data.readItems.${item}`),
              }))}
            />
            <DataTable
              title={t('productIntro.hiLink.data.writeTitle')}
              direction={t('productIntro.hiLink.data.writeDirection')}
              rows={readItems.map((module) => ({
                module: module.replace('module', ''),
                description: writeItems[module]
                  ? t(`productIntro.hiLink.data.writeItems.${writeItems[module]}`)
                  : '-',
              }))}
            />
          </div>
          <p className="hilink-data-notice">{t('productIntro.hiLink.notice.description')}</p>
        </div>
      </section>
    </ProductDetailLayout>
  );
}

function DataTable({ title, direction, rows }) {
  return (
    <div className="hilink-data-table-panel">
      <table className="hilink-data-table" aria-label={title}>
        <colgroup>
          <col className="hilink-data-module-column" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="colgroup" colSpan={2}>
              {title}
              <span className="hilink-data-direction">{direction}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.module}>
              <th scope="row">Module {row.module}</th>
              <td>{row.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
